// Utility functions for venue color mapping
export const VENUE_COLORS = [
  'rgba(150, 206, 180, 0.2)', // Light Green
  'rgba(254, 202, 87, 0.2)',  // Light Orange
  'rgba(78, 205, 196, 0.2)',  // Light Teal
  'rgba(84, 160, 255, 0.2)',  // Light Blue
  'rgba(255, 159, 243, 0.2)', // Light Pink
  'rgba(95, 39, 205, 0.2)',   // Light Purple
  'rgba(0, 210, 211, 0.2)',   // Light Cyan
  'rgba(255, 107, 107, 0.2)', // Light Red
  'rgba(238, 90, 36, 0.2)',   // Light Dark Orange
  'rgba(9, 132, 227, 0.2)',   // Light Dark Blue
  'rgba(108, 92, 231, 0.2)',  // Light Light Purple
  'rgba(162, 155, 254, 0.2)', // Light Lavender
  'rgba(253, 121, 168, 0.2)', // Light Rose Pink
];

/**
 * Get the background color for a venue based on its ID
 * @param venueId - The ID of the venue
 * @returns The rgba color string for the venue (light opacity)
 */
export const getVenueColor = (venueId: number): string => {
  if (!venueId) return VENUE_COLORS[0]; // Default to first color if no ID
  
  // Use modulo to cycle through colors, with venue 16+ using the same color as venue 15
  const colorIndex = Math.min((venueId - 1) % VENUE_COLORS.length, VENUE_COLORS.length - 1);
  return VENUE_COLORS[colorIndex];
};

/**
 * Get contrasting text color for venue badges
 * Since all venue colors are light (rgba with 0.2 opacity), 
 * we use dark text for optimal contrast
 * @param backgroundColor - The rgba background color
 * @returns The text color for optimal contrast
 */
export const getContrastingTextColor = (backgroundColor: string): string => {
  // For light backgrounds (rgba with low opacity), always use dark text
  return '#495057'; // Dark gray for better readability on light backgrounds
};
